<app-dialog
  [title]="'Feedback'"
  [actions]="[{ text: 'Cancel', buttonStyle: 'underline' }, { text: 'Submit',spin: spin,isDisabled: feedBackForm.invalid || !isDisable }]"
  (action)="close($event)"
  (close)="close()"
>
  <form class="feedback-form" [formGroup]="feedBackForm">
    <p class="subscription-title">You are about to unsubscribe from <span *ngFor="let product of products">{{product.name | titlecase}} </span></p> 
    <div class="subscription-row">
      <div class="subscription" *ngFor="let product of products">      
        <div class="subscription-type" [ngClass]="product.name ? product.name : ''">
          <img [src]="product.img" alt="">
          <span>{{product.name | titlecase}}</span>
        </div>    
      </div>
    </div>

    <p class="feedback-form_description" *ngIf="!data?.selectedProductIds?.length">We’re sorry to see you go. Kindly give us some
      insight in your decision.</p>
    <p class="feedback-form_description" *ngIf="data?.selectedProductIds?.length">Kindly give us some insight on your decision.</p>
  
    <div class="custom-mat-radio">
      <mat-radio-button
        [value]="'Current features are not useful to me'"
        (change)="onchange($event)"
        >Current features are not useful to me </mat-radio-button
      >
    </div>
    <!--<div class="custom-mat-radio">
      <mat-radio-button
        [value]="'Still useful but not for this price'"
        (change)="onchange($event)"
        >Still useful but not for this price</mat-radio-button
      >
    </div>
    <div class="custom-mat-radio">
      <mat-radio-button [value]="'was never useful'" (change)="onchange($event)"
        >Was never useful</mat-radio-button
      >
    </div>-->
    <div class="custom-mat-radio">
      <mat-radio-button
        [value]="'I am switching to another software'"
        (change)="onchange($event,'specify')"
        >I am switching to another software</mat-radio-button
      >
      <div class="input-container">
        <input
          class="input-container_input input-container_input--small w-100"
          type="text"
          placeholder="Please specify"
          formControlName="specify"
          [readonly] = "feed !== 'I am switching to another software' ? true : false"
        />
      </div>
    </div>

    <div class="custom-mat-radio">
      <mat-radio-button [value]="'Others'" (change)="onchange($event,'othersReason')"
        >Other</mat-radio-button
      >
      <div class="input-container">
        <input
          class="input-container_input input-container_input--small w-100"
          type="text"
          placeholder="Kindly elaborate"
          formControlName="othersReason"
          [readonly] = "feed !== 'Others' ? true : false"
        />
      </div>
    </div>
    <div class="comment-box">
      <label class="control-label" for="">Comment</label>
      <textarea
        name=""
        id=""
        cols="30"
        rows="5"
        formControlName="comment"
        class="form-control"
        placeholder="Write..."
      ></textarea>
    </div>
  </form>
</app-dialog>
